export default __webpack_public_path__ + "static/media/icon_trigger.c4291240.svg";